import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Currency extends BaseModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  symbol;

  /**
   * @var {string}
   */
  symbolNative;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  code;

  /**
   * @var {boolean}
   */
  active;

  constructor(model = {}) {
    super();
    this.id = model.id;
    this.symbol = model.symbol;
    this.symbolNative = model.symbolNative;
    this.name = model.name;
    this.code = model.code;
    this.active = model.active;
  }
}
